import { render, staticRenderFns } from "./Edge.vue?vue&type=template&id=31eeaf46&"
import script from "./Edge.vue?vue&type=script&lang=js&"
export * from "./Edge.vue?vue&type=script&lang=js&"
import style0 from "./Edge.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports